import { render, staticRenderFns } from "./RejectGroupRequestDetails.vue?vue&type=template&id=422deb00"
import script from "./RejectGroupRequestDetails.vue?vue&type=script&lang=js"
export * from "./RejectGroupRequestDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports